<div class="card shadow-sm">
  <div class="card-header d-flex justify-content-between align-items-center">
    <h3 class="card-title mb-0">Date</h3>
    <div class="d-flex justify-content-end ms-auto gap-2 content-waiting-time">
      <div class="rounded-circle circle-waiting-time" [class]="getWaitingTimeClass()"></div>
      <div class="rounded-circle circle-waiting-time" [class]="getWaitingTimeClass()"></div>
    </div>
  </div>
  <div class="card-body">
    @if (alertInfo.show) {
      <ngb-alert [type]="alertInfo.type" (closed)="alertInfo.show = false">
        {{ alertInfo.message }}
      </ngb-alert>
    }
    <form [formGroup]="form">
      <div class="row">
        <div class="col-md-6">
          <input-field type="text" [inputFormControl]="getRequestCodeInput()" label="Code"
            placeholder="Code" [readonly]="readonlyRequestDate" />
        </div>
        <div class="col-md-6">
          <input-field type="datetime-local" [inputFormControl]="getRequestRequestDateInput()" label="Request Date"
            placeholder="Request Date" [readonly]="readonlyRequestDate"/>
        </div>
      </div>
      <div class="row mt-2 row-request">
        <div class="col-md-12 d-flex flex-column rounded text-white bg-primary py-3">
          <label class="fw-bold ">REQUEST</label>
          <switch-field [isChecked]="getRequestRequestInput().value" message="Request technical call"
            (isCheckedChange)="getRequestRequestInput().setValue($event)" [readonly]="readonlyRequestDate" [primaryBackground]="true"/>
        </div>
      </div>
      <div class="row mt-2 row-status">
        <div class="col-md-12 d-flex flex-column rounded text-white bg-primary py-3">
          <label class="fw-bold">STATUS</label>
          <div class="row">
            <div class="col-12 d-felx align-items-center justify-content-arround">
              <div class="row w-100"
                [style]="this.getRequestStatusInput().value === true ?  ' ' : 'margin-top:32px'">
                <div class="col-7 d-grid align-items-center">
                  <switch-field [isChecked]="getRequestStatusInput().value" message="Taking care"
                    (isCheckedChange)="getRequestStatusInput().setValue($event)" [readonly]="readonlyRequestDate"
                    (valueChange)="onStatusChange($event)" [primaryBackground]="true" />
                </div>
                <div class="col-5">
                  @if (this.getRequestStatusInput().value === true ) {
                    <input-field type="text" [inputFormControl]="getRequestTakingOverInput()"
                      placeholder="Taking over" [readonly]="readonlyRequestDate"
                      />
                  }
                </div>
              </div>
            </div>
            <div class="col-12 d-flex align-items-center">
              <div class="row w-100">
                <div class="col-7 d-grid align-items-center">
                  <switch-field [isChecked]="getRequestReminderInput().value" message="Reminder"
                    (isCheckedChange)="getRequestReminderInput().setValue($event)" [readonly]="readonlyRequestDate" [primaryBackground]="true"/>
                </div>
                <div class="col-5 d-flex flex-row-reverse justify-content-end">
                  <input-field type="datetime-local" [inputFormControl]="getRequestReminderDateInput()" [readonly]="readonlyRequestDate" />
                </div>
              </div>
            </div>
          </div>


        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <select-field [selectFormControl]="getRequestSourceSelect()" [options]="sourceOptions"
            label="Source" [readonly]="readonlyRequestDate"/>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <label class="fw-bold py-2">Category</label>
          <checkbox-field [options]="categoriesOptions" [selectedValues]="getRequestCategoryInput().value"
            (selectedValuesChange)="onCategoriesChange($event)" [readonly]="readonlyRequestDate"
            [hasError]="!!categoryError || getRequestCategoryInput().invalid"/>
          @if (categoryError) {
            <div class="text-danger small mt-1">
              {{ categoryError }}
            </div>
          }
        </div>
      </div>
    </form>
  </div>
</div>